"use strict";

exports.__esModule = true;
exports.SelectionContextWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _EditableSelectionContextElement = require("./EditableSelectionContextElement");
var _SelectionContextElement = require("./SelectionContextElement");
var _SelectionContextFields = require("./SelectionContextFields");
var _SelectionContextHeader = require("./SelectionContextHeader");
var _SelectionContextThumbnail = require("./SelectionContextThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectionContextWidget = exports.SelectionContextWidget = {
  name: "SelectionContext",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SelectionContextWidget.label",
    defaultMessage: "Selection Context"
  }),
  icon: "dashboard",
  createElement: function createElement(props) {
    return {
      type: "SelectionContext",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["device"],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _SelectionContextHeader.SelectionContextHeader,
    Element: _SelectionContextElement.SelectionContextElement,
    Fields: _SelectionContextFields.SelectionContextFields,
    Editable: _EditableSelectionContextElement.EditableSelectionContextElement,
    Thumbnail: _SelectionContextThumbnail.SelectionContextThumbnail
  }
};